module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: [
      "form" ],
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_vm._t("default"), _vm._v(" "), (!_vm.hasErrorModule) ? _c('module-error', {
    attrs: {
      "id": _vm.id
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2bf99b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form.vue
// module id = 254
// module chunks = 2